import { Routes } from '@angular/router';

import { AuthGuard } from '@app/_guards/auth.guard';
import { NonInfluencerGuard } from '@app/_guards/non-influencer.guard';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { CreateCampaignComponent } from '@app/modules/campaign/create-campaign/create-campaign.component';

export const CAMPAIGN_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: CampaignsComponent
      },
      {
        path: 'projects/:id/campaigns/create',
        component: CreateCampaignComponent,
        data: {navTitle: 'New campaign'}
      },
      {
        path: 'projects/:id/campaigns/create/:audienceType',
        component: CreateCampaignComponent,
        data: {navTitle: 'New campaign'}
      }
    ],
    canActivate: [AuthGuard, NonInfluencerGuard]
  }
];
